<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="container" v-loading="loading">
      <titleConfig
        :title="langSet == 'cn' ? '个人资料' : 'Personal Information'"
        :type="2"
      ></titleConfig>
      <div class="personal_wrap flex flex_content_center flex_wrap">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          :label-position="isShowPC ? 'left' : 'top'"
          class="personal_form"
        >
          <div class="head_wrap">
            <img class="head_img" :src="ruleForm.avatar" alt="" />
            <div class="head_btn_wrap flex flex_content_center">
              <el-upload
                class="upload-demo"
                :action="$Url + '/pc/upload/image'"
                :headers="headers"
                :show-file-list="false"
                :on-progress="handleProgress"
                :on-success="handleAvatarSuccess"
              >
                <div class="head_btn head_change">
                  {{ langSet == "cn" ? "修改头像" : "Update avatar" }}
                </div>
              </el-upload>
              <div class="head_btn" @click="handleDialog">
                {{ langSet == "cn" ? "认证展商" : "Certified Exhibitors" }}
              </div>
            </div>
          </div>
          <el-form-item
            :label="langSet == 'cn' ? '姓名' : 'Name'"
            prop="nickname"
          >
            <el-input
              v-model="ruleForm.nickname"
              :placeholder="
                langSet == 'cn' ? '请输入姓名' : 'Please enter name'
              "
            ></el-input>
          </el-form-item>
          <el-form-item :label="langSet == 'cn' ? '手机' : 'Phone Number'">
            <el-input
              v-model="mobile"
              :placeholder="
                langSet == 'cn' ? '请输入手机' : 'Please enter phone number'
              "
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '电子邮件' : 'E-mail'"
            prop="email"
          >
            <el-input
              v-model="ruleForm.email"
              :placeholder="
                langSet == 'cn' ? '请输入电子邮件' : 'Please enter email'
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '公司名称' : 'Company'"
            prop="companyName"
          >
            <el-input
              v-model="ruleForm.companyName"
              :placeholder="
                langSet == 'cn' ? '请输入公司名称' : 'Please enter company'
              "
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '行业属性' : 'industry'"
            prop="industry"
          >
            <el-select
              v-model="ruleForm.industry"
              placeholder="请选择/Please choose"
            >
              <el-option
                v-for="item in industryOptions"
                :key="item.linkageid"
                :label="langSet == 'cn' ? item.name : item.description"
                :value="item.linkageid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '部门属性' : 'department'"
            prop="department"
          >
            <el-select
              v-model="ruleForm.department"
              placeholder="请选择/Please choose"
            >
              <el-option
                v-for="item in departmentOptions"
                :key="item.linkageid"
                :label="langSet == 'cn' ? item.name : item.description"
                :value="item.linkageid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '职务级别' : 'Duties'"
            prop="duties"
          >
            <el-select
              v-model="ruleForm.duties"
              placeholder="请选择/Please choose"
            >
              <el-option
                v-for="item in dutiesOptions"
                :key="item.linkageid"
                :label="langSet == 'cn' ? item.name : item.description"
                :value="item.linkageid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{
              langSet == "cn" ? "保存" : "Save"
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-dialog width="400px" :visible.sync="dialogVisible" :show-close="false">
      <div class="dialog_wrap">
        <div class="dialog_title">
          {{ langSet == "cn" ? "展商认证" : "Certified Exhibitors" }}
        </div>
        <el-form
          :model="companyForm"
          :rules="companyFormRules"
          ref="companyForm"
          label-width="80px"
          label-position="top"
          class="personal_form"
        >
          <el-form-item
            :label="langSet == 'cn' ? '账号' : 'Account number'"
            prop="username"
          >
            <el-input
              v-model="companyForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '密码' : 'Password'"
            prop="password"
          >
            <el-input
              v-model="companyForm.password"
              type="password"
              placeholder="请输入"
            ></el-input>
            <div class="dialog_tips">
              {{
                langSet == "cn"
                  ? "请向您企业展会负责人所要验证信息"
                  : "Please request verifcation information from the person in charge of your company's exhibition"
              }}
            </div>
          </el-form-item>
          <el-form-item class="no-label">
            <el-button
              type="primary"
              @click="submitCompanyForm('companyForm')"
              >{{ langSet == "cn" ? "提交" : "Submit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import {
  getLinkage,
  userInfo,
  updateInfo,
  companyAttestation,
} from "@/api/api";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      metaData: {},
      langSet: "",
      mobile: "",
      headers: {},
      ruleForm: {
        nickname: "",
        companyName: "",
        email: "",
        industry: "",
        department: "",
        duties: "",
        avatar: "",
      },
      rules: {
        nickname: [
          {
            required: true,
            message: "请输入姓名/please enter name",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入公司/please enter company",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "请选择/please choose",
            trigger: "blur",
          },
        ],
      },
      companyForm: {
        username: "",
        password: "",
      },
      companyFormRules: {
        username: [
          {
            required: true,
            message: "请输入账号/please enter account number",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码/please enter password",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
      loading: false,
      isShowPC: true,
      industryOptions: [],
      departmentOptions: [],
      dutiesOptions: [],
    };
  },
  created() {},
  activated() {},
  mounted() {
    this.langSet = this.$language;
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    //25.9.18  判断是否移动端 dxm
    this.isMobile();
    //25.9.18 获取选项 dxm
    this.getLinkageData("4220,4221,4222");
    //25.9.18 获取个人信息 dxm
    this.getUserInfo();
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    async getLinkageData(keyid) {
      const res = await getLinkage({ keyid });
      console.log(res, "===res");
      this.industryOptions = res.data[4220];
      this.departmentOptions = res.data[4221];
      this.dutiesOptions = res.data[4222];
    },
    async getUserInfo() {
      this.loading = true;
      const res = await userInfo();
      let {
        nickname,
        avatar,
        mobile,
        companyName,
        department,
        industry,
        duties,
        email,
      } = res.data;
      this.mobile = mobile;
      this.ruleForm.avatar = avatar;
      this.ruleForm.nickname = nickname || "";
      this.ruleForm.companyName = companyName || "";
      this.ruleForm.industry = industry || "";
      this.ruleForm.department = department || "";
      this.ruleForm.duties = duties || "";
      this.ruleForm.email = email || "";
      this.loading = false;
    },
    handleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    async submitForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          await updateInfo(this.ruleForm);
          this.$message.success("提交成功");
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error("保存失败，请检查输入信息");
          return false;
        }
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        console.error("submit error:", err);
        this.loading = false;
      }
    },
    async submitCompanyForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          await companyAttestation(this.companyForm);
          this.$message.success("认证成功");
          this.dialogVisible = false;
        } else {
          this.$message.error("认证失败，请检查输入信息");
          return false;
        }
        this.loading = false;
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        this.loading = false;
      }
    },
    handleProgress() {
      this.loading = true;
    },
    async handleAvatarSuccess(res, file) {
      if (res.code == 1) {
        this.ruleForm.avatar = res.data.uri;
      } else if (res.code == -1) {
        this.$message.error(res.msg);
        setTimeout(() => {
          this.$router.push({
            path: "/login",
          });
        }, 1000);
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 80px 0 0;
}
.personal_wrap {
  margin: 30px 0;
  padding: 30px 0 70px;
  box-sizing: border-box;
  background: #f7f8fa;
  .head_wrap {
    width: 100%;
    margin-bottom: 20px;
    .head_img {
      width: 100px;
      height: 100px;
      margin: 0 auto 10px;
      border-radius: 50%;
    }
    .head_btn {
      width: 100px;
      height: auto;
      color: #fff;
      padding: 7px 0;
      font-size: 14px;
      cursor: pointer;
      line-height: 20px;
      text-align: center;
      background: #90c31f;
      border-radius: 17px;
      border: 1px solid #90c31f;
      margin-bottom: 10px;
    }
    .head_change {
      color: #004190;
      margin-right: 10px;
      background: #fff;
      border-color: #004190;
    }
  }
  .personal_form {
    width: 504px;
    /deep/ .el-form-item {
      margin-bottom: 25px;
    }
    /deep/ .el-input__inner {
      height: 52px;
      line-height: 52px;
      font-size: 16px;
      border-radius: 8px;
      border-color: #fff;
    }
    /deep/ .el-input.is-disabled .el-input__inner {
      border-color: #e4e7ed;
    }
    /deep/ .el-select {
      width: 100%;
    }
    /deep/ .el-button--primary {
      width: 168px;
      height: 52px;
      font-size: 18px;
      margin: 0 auto;
      display: block;
      border-radius: 30px;
      background: #004190;
      border-color: #004190;
    }
  }
}
/deep/ .el-dialog {
  height: 387px;
  margin-top: 0;
  background: #004190;
  border-radius: 20px;
  .el-dialog__body {
    color: #fff;
    padding: 0 30px;
  }
  .dialog_title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
  }
  .el-form-item__label {
    color: #fff;
    font-size: 16px;
    line-height: 22px;
  }
  .el-button--primary {
    width: 180px;
    font-size: 16px;
    background: #e62344;
    border-color: #e62344;
    border-radius: 5px;
    margin: 0 auto;
    display: block;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item__error {
    top: 10px;
    left: auto;
    right: 15px;
  }
  .dialog_tips {
    padding-top: 10px;
    line-height: 20px;
  }
}
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .container {
    padding-top: 0.58rem;
  }
  .personal_wrap {
    height: auto;
    flex-wrap: wrap;
    padding: 0;
    margin-top: 0;
    position: relative;
    background: transparent;
    /deep/ .el-form {
      width: 100%;
      padding: 0.38rem;
      margin-top: 1.9rem;
      box-sizing: border-box;
      background: #f7f8fa;
      border-radius: 20px;
    }
    .personal_form {
      .el-form-item {
        margin-bottom: 0.29rem;
      }
      /deep/.el-form-item__label {
        line-height: 0.42rem;
        padding-bottom: 0.1rem;
      }
      .no-label .el-form-item__content{
        margin-left: 0;
      }
      .el-button--primary {
        width: 5.96rem;
        height: 0.81rem;
        padding: 0;
        font-size: 0.27rem;
        line-height: 0.81rem;
        margin: 0.48rem auto 0;
        display: block;
      }
    }
    .head_wrap {
      .head_img {
        margin: -1.3rem auto 15px;
      }
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
    height: auto;
    .el-form-item__label {
      margin-bottom: 0.19rem;
    }
  }
}
</style>